function organizeAttrs( attrs ) {
  const relationships = []
  const rtn = { path : '', groups : {}, children : [], relationships }

  for ( let i = 0; i < attrs.length; i++ ) {
    const attr = attrs[i]
    if ( attr.type === 'relationship' || attr.type === 'parentRelationship' ) {
      relationships.push( attr )
    } else if ( attr.path.indexOf( '/' ) < 0 ) {
      rtn.children.push( attr )
    } else {
      let curr = rtn
      const path = attr.path.split( '/' )
      for ( let n = 0; n < path.length - 1; n++ ) {
        const name = path[n]
        if ( curr.groups[name] == null ) {
          curr.groups[name] = { 
            type : 'group', 
            name, 
            path : `${curr.path}${n === 0 ? '' : '/'}${name}`, 
            groups : {}, 
            children : [] }
          curr.children.push( curr.groups[name] )
        }
        curr = curr.groups[name]
      }
      curr.children.push( attr )

    }
  }
  return rtn
}

export default {
  organizeAttrs
}
